import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppDispatch } from 'store/configStore'
import {
    clientSearchAction,
    clearClientSearchAction,
    sendInteractionsAction,
    fetchTargetListAction,
    processTargetListAction,
    filterTargetListAction,
    markNotificationReadAction,
    fetchUnreadNotificationsAction,
    getVeInteractionsAction,
    saveVeSearchResults,
    setLastVisitedClientAction,
    clearLastVisitedClientAction,
    resetTargetListFilterAction,
    clientSearchByPhoneAction
} from '../actions'
import {
    enrollmentAction,
    storeEnrollmentFormAction,
    updatePackagesAction,
    clientDetailsEnrollmentAction,
    saveClientState,
    selectProduct,
    addPacket,
    removePacket,
    savePaymentState
} from 'features/enrollment/enrollmentSlice'
import { fetchInteractionsAction } from 'actions/interactionsActions'
import {
    getStoredVeDeposit,
    resetStoredVeDeposit
} from 'features/veDeposits/storedVeDepositsSlice'
import { processNavbar } from 'features/navbar/navbarSlice'
import { loginAction, logout } from 'features/auth/authSlice'
import { veCardInventoryAction } from 'features/card/veCardInventorySlice'
import {
    checkPaymentConfirmation,
    clearMobilePaymentAction,
    mobilePaymentAction
} from 'features/mobilePayment/mobilePaymentSlice'
import {
    fetchCountryEnrollment,
    fetchCountryConfig
} from 'features/fcHome/fcHomeSlice'
import { homeAction } from 'features/home/homeSlice'
import {
    villageClientListAction,
    selectVillageClient,
    prevSelectVillageClient,
    storeVillageClientListAction,
    openVillagePageAction,
    updateSingleClientBalAndSmsAction,
    setSelectionVillageUrl,
    clearSelectionVillageInfo,
    clearSingleClientData,
    selectedClientAction,
    resetSelectVillageClient,
    refreshVillageClientListAction,
    handleMultipleVillagesCountAction,
    getVeClientListAction,
    filterSelectorAction
} from 'features/villageClient/villageClientSlice'
import { fetchTransactionsAction } from 'features/transactions/transactionSlice'
import { getUserPermissionsAction } from 'features/userPermissions/userPermissionsSlice'
import { veDepositsAction } from 'features/veDeposits/veDepositSlice'
import { veRankingAction } from 'features/ranking/rankingSlice'
import { fcMetricsAction } from 'features/fcMetrics/fcMetricsSlice'
import {
    fetchAssignedVillagesAction,
    fetchVesAction
} from 'features/ves/vesSlice'
import {
    getVeAction,
    resetVeAction,
    selectVeVillageAction
} from 'features/ve/veSlice'
import {
    updatePaymentCelebrationDataAction,
    getPaymentCelebrationDataAction
} from 'features/paymentCelebration/paymentCelebrationSlice'
import {
    loadBulkEnrollmentClients,
    initializeBulkEnrollment,
    ensureBulkEnrollmentVillage,
    selectBulkEnrollmentPackage,
    setBulkEnrollmentRows,
    addBulkEnrollmentRow,
    removeBulkEnrollmentRow,
    updateBulkEnrollmentRow,
    confirmBulkEnrollmentRow,
    commitBulkEnrollmentRow,
    clearBulkEnrollmentRow,
    setBulkEnrollmentActiveDropdownRow,
    clearBulkEnrollmentSubmitError,
    resetBulkEnrollment,
    enrollBulkEnrollmentRow,
    submitBulkEnrollment
} from 'features/bulkEnrollment/bulkEnrollmentSlice'
import {
    setIsVisitedAction,
    showWarningModalAction,
    visitPostAction
} from 'features/visit/visitSlice'
import {
    getClientOrdersAction,
    resetClientOrdersAction,
    storeVillageOrdersAction
} from 'features/clientOrders/clientOrdersSlice'

export const useBindDispatch = () => {
    const dispatch = useDispatch<AppDispatch>()
    return bindActionCreators(
        {
            loginDispatch: loginAction,
            logoutDispatch: logout,
            navbarHandler: processNavbar,
            productListHandler: enrollmentAction,
            storeEnrollmentFormHandler: storeEnrollmentFormAction,
            villageClientListHandler: villageClientListAction,
            fetchVeClientListHandler: getVeClientListAction,
            storeVillageClientListHandler: storeVillageClientListAction,
            refreshVillageClientListHandler: refreshVillageClientListAction,
            selectVillageClientHandler: selectVillageClient,
            veRankingHandler: veRankingAction,
            selectVillagePrevClientActionHandler: prevSelectVillageClient,
            openVillagePageHandler: openVillagePageAction,
            filterSelectorHandler: filterSelectorAction,
            veDepositsHandler: veDepositsAction,
            getUserPermissionHandler: getUserPermissionsAction,
            updatePackagesActionHandler: updatePackagesAction,
            clientDetailsEnrollmentHandler: clientDetailsEnrollmentAction,
            clientSearchHandler: clientSearchAction,
            clientSearchByPhoneHandler: clientSearchByPhoneAction,
            visitSubmissionHandler: visitPostAction,
            updateSingleClientBalAndSmsHandler:
                updateSingleClientBalAndSmsAction,
            villageSelectionInfoHandler: setSelectionVillageUrl,
            clearClientSearchHandler: clearClientSearchAction,
            storeVillageOrdersHandler: storeVillageOrdersAction,
            getClientOrdersHandler: getClientOrdersAction,
            resetClientOrdersHandler: resetClientOrdersAction,
            clearVillageSelectionInfoHandler: clearSelectionVillageInfo,
            clearSingleClientDataHandler: clearSingleClientData,
            transactionsHandler: fetchTransactionsAction,
            sendInteractionsActionHandler: sendInteractionsAction,
            fetchTargetListHandler: fetchTargetListAction,
            processTargetListHandler: processTargetListAction,
            fetchInteractionsHandler: fetchInteractionsAction,
            getInteractionsHandler: getVeInteractionsAction,
            filterTargetListHandler: filterTargetListAction,
            setIsVisitedHandler: setIsVisitedAction,
            showWarningModalHandler: showWarningModalAction,
            resetSelectVillageClientActionHandler: resetSelectVillageClient,
            saveClientsStateHandler: saveClientState,
            selectProductHandler: selectProduct,
            addPacketsHandler: addPacket,
            removePacketsHandler: removePacket,
            savePaymentsStateHandler: savePaymentState,
            selectedClientHandler: selectedClientAction,
            handleMultipleVillagesCountHandler:
                handleMultipleVillagesCountAction,
            markNotificationReadHandler: markNotificationReadAction,
            fetchUnreadNotificationsHandler: fetchUnreadNotificationsAction,
            fcMetricsHandler: fcMetricsAction,
            fetchVesHandler: fetchVesAction,
            fetchAssignedVillagesHandler: fetchAssignedVillagesAction,
            veCardInventoryHandler: veCardInventoryAction,
            getVeHandler: getVeAction,
            resetVeHandler: resetVeAction,
            getVeDepositHandler: getStoredVeDeposit,
            resetVeDepositHandler: resetStoredVeDeposit,
            saveVeSearchResultsHandler: saveVeSearchResults,
            selectVeVillageHandler: selectVeVillageAction,
            updatePaymentCelebrationDataHandler:
                updatePaymentCelebrationDataAction,
            getPaymentCelebrationDataHandler: getPaymentCelebrationDataAction,
            setLastVisitedClientHandler: setLastVisitedClientAction,
            clearLastVisitedClientHandler: clearLastVisitedClientAction,
            fetchCountryEnrollmentHandler: fetchCountryEnrollment,
            fetchCountryConfigHandler: fetchCountryConfig,
            requestMobilePaymentHandler: mobilePaymentAction,
            clearMobilePaymentHandler: clearMobilePaymentAction,
            checkPaymentConfirmationHandler: checkPaymentConfirmation,
            homeHandler: homeAction,
            resetTargetListFilterHandler: resetTargetListFilterAction,
            loadBulkEnrollmentClientsHandler: loadBulkEnrollmentClients,
            initializeBulkEnrollmentHandler: initializeBulkEnrollment,
            ensureBulkEnrollmentVillageHandler: ensureBulkEnrollmentVillage,
            selectBulkEnrollmentPackageHandler: selectBulkEnrollmentPackage,
            setBulkEnrollmentRowsHandler: setBulkEnrollmentRows,
            addBulkEnrollmentRowHandler: addBulkEnrollmentRow,
            removeBulkEnrollmentRowHandler: removeBulkEnrollmentRow,
            updateBulkEnrollmentRowHandler: updateBulkEnrollmentRow,
            confirmBulkEnrollmentRowHandler: confirmBulkEnrollmentRow,
            commitBulkEnrollmentRowHandler: commitBulkEnrollmentRow,
            clearBulkEnrollmentRowHandler: clearBulkEnrollmentRow,
            setBulkEnrollmentActiveDropdownRowHandler:
                setBulkEnrollmentActiveDropdownRow,
            clearBulkEnrollmentSubmitErrorHandler:
                clearBulkEnrollmentSubmitError,
            resetBulkEnrollmentHandler: resetBulkEnrollment,
            enrollBulkEnrollmentRowHandler: enrollBulkEnrollmentRow,
            submitBulkEnrollmentHandler: submitBulkEnrollment
        },
        dispatch
    )
}
